import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import globalContext from '../../../../config/context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 400,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogCustom = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {
    tahun,
    setTahun,
    kecamatan,
    setKecamatan,
    handleKecamatan,
    itemKecamatan,
    kelurahan,
    setKelurahan,
    handleKelurahan,
    itemKelurahan,
    onZnt,
  } = props;

  const [layer, setlayer] = React.useState('');

  const handleChange = (event) => {
    setlayer(event.target.value);
  };

  return (
    <div className={classes.root}>
      <FormControl variant="outlined" className={classes.comboBox}>
        <InputLabel id="layer-select-outlined-label">Select Layer</InputLabel>
        <Select
          labelId="layer-select-outlined-label"
          id="layer-select-outlined"
          value={layer}
          onChange={handleChange}
          label="Select Layer">
          <MenuItem value={12}>Kelurahan</MenuItem>
          <MenuItem value={13}>Blok</MenuItem>
          <MenuItem value={14}>Persil</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default DialogCustom;
